import { render, staticRenderFns } from "./TimeLimitEditor.vue?vue&type=template&id=29186d8d&scoped=true&"
import script from "./TimeLimitEditor.vue?vue&type=script&lang=js&"
export * from "./TimeLimitEditor.vue?vue&type=script&lang=js&"
import style0 from "./TimeLimitEditor.vue?vue&type=style&index=0&id=29186d8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29186d8d",
  null
  
)

export default component.exports